@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-tabs-navigation-top-offset: 48px;
$var-actions-top-offset: -16px;

.job-preview {

	&__back-to-list {
		background-color: Colors.$col-white !important;
		margin-bottom: Constants.$val-spacing-m;
	}

	&__submit-section {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: Constants.$val-spacing-m;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 2px solid Colors.$col-greyBackground;

		.title-container {
			flex: 1;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: Constants.$val-spacing-m;

			.title {
				font-size: Constants.$val-fontSizeXBig;
				text-transform: uppercase;
			}

			.main-job-title {
				font-size: Constants.$val-fontSizeBig;
				line-height: Constants.$val-fontSizeBig;
			}
		}

		.actions {
			display: flex;
			align-items: center;
			gap: Constants.$val-spacing-xs;
		}
	}

	&__submit-section-sticky {
		top: $var-actions-top-offset;
		position: sticky;
	}

	&__additional-info {

		background-color: Colors.$col-white;
		box-shadow: $var-shadow;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;

		&__accordion {
			margin-bottom: Constants.$val-spacing-m;
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;


		&__section {
			background-color: Colors.$col-white;
			box-shadow: $var-shadow;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l
		}
	}

}

.text-strong {
	font-weight: bold;
}

.text-red {
	color: Colors.$col-red !important;
}

.text-black {
	color: Colors.$col-blackDark !important;
}

.single-line-text {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.work-order-info-modal {

	&__report-link {

		&, &:active {
			color: Colors.$col-blue;
			background-color: transparent !important;
			border: none !important;
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			font-weight: normal;
			cursor: pointer;
			padding: 0;
		}

		&:hover, &:focus, &:focus:active {
			text-decoration: none;
			color: Colors.$col-blueHover;
		}
	}

	&__icon-text {
		margin-right: 4px;
	}
}

.link-cell {
	&__icon {
		color: Colors.$col-blue;
		font-size: Constants.$val-fontSizeXBig;
	}
}

.table-filter {
	display: flex;
	justify-content: flex-end;
}

.billing-code-group-cell {
	display: flex;
	justify-content: start;
	align-items: center;
	flex-direction: row;
	gap: Constants.$val-spacing-xs;
}

.text-cell {
	display: block;
	width: 100%;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.archived {
	color: Colors.$col-design-grey400 !important;
	background-color: Colors.$col-greyBackgorund2 !important;
	width: 100%;
}

.info-icon {
	font-size: Constants.$val-fontSizeBig;
	cursor: pointer;
	color: Colors.$col-design-blue500 !important;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: Constants.$val-spacing-s;
}

.archive-icon {
	font-size: Constants.$val-fontSizeBig;
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: Constants.$val-spacing-s;

	:global(.icon-archive),
	:global(.icon-archive::before) {
		color: Colors.$col-design-grey11 !important;
	}
}